<template>
	<Row class="page-container-row">
		<Col
			:span="24"
			:offset="0"
			:lg="{ span: 18, offset: 3 }"
			:xl="{ span: 12, offset: 6 }"
		>
			<PageContainer :withCloseButton="false">
				<Result
					:status="icon"
					:title="$t('license.header.' + step)"
					:sub-title="subTitle ? $t('license.' + subTitle) : ''"
				>
					<template v-if="step === 'check'" #icon>
						<LoadingOutlined />
					</template>
					<template v-if="showButton" #extra>
						<div class="button-wrapper">
							<Button v-if="step === 'ok'" type="primary" @click="closePage">
								{{ $t('license.closeButtonLabel') }}
							</Button>
							<UploadButton
								v-else
								buttonType="primary"
								:label="$t('license.uploadButtonLabel')"
								action="license/upload/"
								:alwaysShowLabel="true"
								:onSuccess="handleUploadSuccess"
							/>
						</div>
					</template>
				</Result>
			</PageContainer>
		</Col>
	</Row>
</template>

<script>
import { ref, computed } from 'vue';

import { Row, Col, Result, Button } from 'ant-design-vue';
import { LoadingOutlined } from '@ant-design/icons-vue';

import { useRouter } from 'vue-router';

import { useLicenseStore } from '@/stores/licenseStore';
import { useUserStore } from '@/stores/user';

import { showErrorMessage } from '@/components/common/errorMessage';

import PageContainer from '@/components/common/PageContainer';
import UploadButton from '@/components/common/UploadButton';


const ICONS = {
	check: null,
	prompt: 'warning',
	needUpdate: 'warning',
	notAccepted: 'error',
	ok: 'success',
};

const SUB_TITLES = {
	check: '',
	prompt: 'expiredAdminText',
	needUpdate: 'needUpdateAdminText',
	notAccepted: 'expiredAdminText',
	ok: '',
};

export default {
	components: {
		Row, Col, Result, Button, LoadingOutlined,
		PageContainer, UploadButton,
	},
	setup() {
		const step = ref('check');
		const icon = computed(() => ICONS[step.value]);
		const subTitle = computed(() => {
			if (useUserStore().allowToUpdateLicense) {
				return SUB_TITLES[step.value];
			}
			return 'expiredUserText';
		});
		const router = useRouter();
		const closePage = () => router.push({ name: 'home-map' });

		const licenseStore = useLicenseStore();
		licenseStore.refresh(() => {
			if (licenseStore.status === 'ok') {
				closePage();
			} else {
				step.value = licenseStore.status === 'needUpdate' ? 'needUpdate' : 'prompt';
			}
		})
		const handleUploadSuccess = response => {
			if (response.status === 'ok') {
				if (response.license_status === 'expired') {
					step.value = 'notAccepted';
				} else {
					step.value = 'ok';
					licenseStore.refresh();
				}
			} else {
				showErrorMessage(response.errors);
			}
		};
		const showButton = computed(() => useUserStore().allowToUpdateLicense && step.value !== 'check');
		return {
			step,
			icon,
			subTitle,
			showButton,
			handleUploadSuccess,
			closePage,
		}
	},
}
</script>

<style scoped>
.button-wrapper {
	width: 150px;
	margin: 0 auto !important;
}
</style>